<template>
	<div class="p-grid p-pb-1">
		<div class="p-col-12 p-pt-1 p-pb-1">

      <div class="p-grid p-nogutter">
        <div class="p-col">
          <h2>
            {{$t('library.title_web')}}
          </h2>
        </div>
        <div class="p-col-fixed p-pb-4" style="width: fit-content">
          <Button v-if="buttonVisible" :label="$t('library.cycle.new_cycle_button')" @click="createCycle" icon="irinox-icon-button pi pi-plus" iconPos="left" />
        </div>
      </div>

      <Library />

      <FunctionSelect :visible="dialog.functionSelect" 
        @update:visible="dialog.functionSelect = $event"
        @select:function="functionSelected" />
      
		</div>
	</div>
</template>

<script>
import Library from './Library.vue';
import FunctionSelect from './FunctionSelect.vue';
import { mapGetters } from 'vuex';

export default {

  components: {
      Library,
      FunctionSelect,
    },
    data() {
        return {
          dialog: {
            functionSelect: false
          }
        };
    },
    computed: {
      ...mapGetters({
          role: 'userdata/role',
        }),
        buttonVisible: function() {
          return this.role === "USER";
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
      createCycle() {
        this.dialog.functionSelect = true;
      },
      functionSelected(functionId) {
        this.dialog.functionSelect = false;
        this.$router.push({ name: 'recipe-create', params: { function: functionId } })
      }
    }

}
</script>

<style scoped>
</style>